<ng-content select="genesis-frontend-recommendation-card-cover"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-icon"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-static"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-media"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-tag"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-feature"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-title"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-text"></ng-content>
<ng-content select="genesis-frontend-recommendation-card-actions"></ng-content>
